import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import DaywiseProfitGraph from '../Shared/DashboardCharts/DaywiseProfitGraph';
import DaywiseSalesGraph from '../Shared/DashboardCharts/DaywiseSalesGraph';
import MonthwiseSalesGraph from '../Shared/DashboardCharts/MonthwiseSalesGraph';
import ThisMonthSales from '../Shared/DashboardCharts/ThisMonthSales';
import TodaySales from '../Shared/DashboardCharts/TodaySales';
import TodayProfit from '../Shared/DashboardCharts/TodayProfit';
import ThisMonthProfit from '../Shared/DashboardCharts/ThisMonthProfit';
import MonthwiseProfitGraph from '../Shared/DashboardCharts/MonthwiseProfitGraph';
import ProfitExpenseNett from '../Shared/DashboardCharts/ProfitExpenseNett';
import ProfitExpenseNettAllTime from '../Shared/DashboardCharts/ProfitExpenseNettAllTime';
import ThisMonthIncomes from '../Shared/DashboardCharts/ThisMonthIncomes';
import ThisMonthExpenses from '../Shared/DashboardCharts/ThisMonthExpenses';
import { FiActivity, FiArrowUpRight } from 'react-icons/fi';
import { useSaasSession } from '../../saas/SessionContext';

const DashboardHome = ({ embedded = false }) => {
    const userAc = useSelector((state) => state.user.user);
    const user = userAc?.email?.split('@')[0] || 'there';
    const { tenant } = useSaasSession();

    return (
        <div className={`dashboard-home mb-40 w-full ${embedded ? 'dashboard-home--embedded' : ''}`}>
            {!embedded && <section className="dashboard-home__hero"><div><small>Business overview</small><h1>Welcome back, {user}</h1><p>{tenant?.settings?.businessName || tenant?.name || 'Your workspace'} at a glance.</p></div><span><FiActivity /></span></section>}
            {/* <div className='mt-12 mb-12 text-right font-bold'>
                <button onClick={() => dispatch(filterServices("Today"))} className={`btn ${filtering==="Today"?'btn-success':'btn-error'} text-white mr-2`}>Today</button>
                <button onClick={() => dispatch(filterServices("This Month"))} className={`btn ${filtering==="This Month"?'btn-success':'btn-error'} text-white mr-2`}>This Month</button>
                <button onClick={() => dispatch(filterServices("This Year"))} className={`btn ${filtering==="This Year"?'btn-success':'btn-error'} text-white mr-2`}>This Year</button>
                <button disabled onClick={() => dispatch(filterServices("Custom"))} className={`btn ${filtering==="Custom"?'btn-success':'btn-error'} text-white mr-2`}>Custom</button>
            </div> */}
            {/* <div>
                <div className='flex gap-px justify-center flex-col lg:flex-row'>
                    <div>
                        <table class="table w-1/2 mx-auto">
                            <caption>Service Quantity {filtering==="Today"?"(Today)":filtering==="This Month"?"(This Month)":filtering==="This Year"?"(This Year)":""}</caption>
                            <thead className='text-center'>
                                <tr>
                                    <th className='bg-primary text-white normal-case'>Total Service</th>
                                    <th className='bg-primary text-white normal-case'>Free Service</th>
                                    <th className='bg-primary text-white normal-case'>Paid Service</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                <tr className='border border-1'>
                                    <td>{services?.length}</td>
                                    <td>{totalFree?.length}</td>
                                    <td>{totalPaid?.length}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div>
                        <table class="table w-1/2 mx-auto">
                            <caption>Service Amount {filtering==="Today"?"(Today)":filtering==="This Month"?"(This Month)":filtering==="This Year"?"(This Year)":""}</caption>
                            <thead className='text-center'>
                                <tr>
                                    <th className='bg-primary text-white normal-case'>Spare Parts Sell</th>
                                    <th className='bg-primary text-white normal-case'>FS Charge</th>
                                    <th className='bg-primary text-white normal-case'>PS Charge</th>
                                    <th className='bg-primary text-white normal-case'>Total</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                <tr className='border border-1'>
                                    <td>{totalSpare}</td>
                                    <td>{freeCharge}</td>
                                    <td>{paidCharge}</td>
                                    <td>{totalSpare + paidCharge}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div>
                        <table class="table w-1/2 mx-auto">
                            <caption>Technician Wise Service {filtering==="Today"?"(Today)":filtering==="This Month"?"(This Month)":filtering==="This Year"?"(This Year)":""}</caption>
                            <thead className='text-center'>
                                <tr>
                                    <th className='bg-primary text-white normal-case'>Technician</th>
                                    <th className='bg-primary text-white normal-case'>Spare Parts</th>
                                    <th className='bg-primary text-white normal-case'>Total Charge</th>
                                    <th className='bg-primary text-white normal-case'>FS Charge</th>
                                    <th className='bg-primary text-white normal-case'>PS Charge</th>
                                    <th className='bg-primary text-white normal-case'>Total Amount</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                {
                                    technicianData.map(technician => <tr className='border border-1'>
                                        <td>{technician?.name}</td>
                                        <td>{technician?.partsSell}</td>
                                        <td>{technician?.totalService} ({technician?.tsQyt})</td>
                                        <td>{technician?.freeService} ({technician?.fsQyt})</td>
                                        <td>{technician?.paidService} ({technician?.psQyt})</td>
                                        <td>{technician?.partsSell + technician?.freeService + technician?.paidService}</td>
                                    </tr>)
                                }
                            </tbody>
                        </table>
                    </div>
                      
                    {/* <div className="btn-group btn-group-vertical lg:btn-group-horizontal">
                        <button className="btn btn-active">Button</button>
                        <button className="btn">Button</button>
                        <button className="btn">Button</button>
                    </div> */}
            <section className="dashboard-home__section-heading"><div><small>Live performance</small><h2>{embedded ? 'Business overview' : 'Today’s numbers'}</h2></div><FiArrowUpRight /></section><div className='dashboard-home__metrics mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mx-2 sm:mx-4'>
                <TodaySales />
                <TodayProfit />
                <ThisMonthSales />
                <ThisMonthProfit />
                <ThisMonthIncomes />
                <ThisMonthExpenses />
            </div>

            <section className="dashboard-home__section-heading"><div><small>Financial health</small><h2>Profit and expense</h2></div></section><div className='dashboard-home__charts grid grid-cols-1 lg:grid-cols-2 gap-3 mx-2 sm:mx-4 mt-4'>
                <ProfitExpenseNett />
                <ProfitExpenseNettAllTime />
            </div>

            <section className="dashboard-home__section-heading"><div><small>Business trends</small><h2>Sales and profit movement</h2></div></section><div className='dashboard-home__charts grid grid-cols-1 lg:grid-cols-2 gap-5 mx-2 sm:mx-4 mt-4'>
                <DaywiseSalesGraph />
                <DaywiseProfitGraph />
                <MonthwiseSalesGraph />
                <MonthwiseProfitGraph />
            </div>


        </div>
        // </div> */}

    );
};

export default DashboardHome;
